<template>
  <div ref="draggableContainer" class="absolute right-3/32 top-3/16 w-75 z-90">
    <div
      @mousedown.prevent="dragWindow"
      class="flex items-center justify-between p-1 bg-gray-600/80 text-gray-100 rounded-t cursor-move font-extralight"
    >
      <div class="inline-block w-full font-medium text-left px-2 uppercase text-lg">
        Identify Results
        <button class="float-right" @click="close">
          <i class="float-right fas fa-xmark items-center py-1 text-gray-300 hover:text-white" />
        </button>
      </div>
    </div>
    <div class="max-h-100 bg-gray-100/80 text-gray-600 text-sm rounded-b overflow-auto">
      <div class="font-medium text-sm border-1 pb-4" v-for="[title, features] in selectedFeatures" :key="title">
        <identify-item :features="features" :title="title"></identify-item>
      </div>
    </div>
    <div @mousedown.prevent="dragWindow" class="h-8 bg-gray-600/80 rounded-b cursor-move"></div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import IdentifyItem from '@/components/map-components/identify/IdentifyItem'
import { defineExpose, ref } from 'vue'

export default {
  name: 'Identify',
  components: { IdentifyItem },
  props: {
    title: {
      type: String,
      default: '',
    },
    selectedFeatures: {
      type: Object,
      default: null,
    },
  },
  setup() {
    const store = useStore()
    const clientX = ref(undefined)
    const clientY = ref(undefined)
    const movementX = ref(0)
    const movementY = ref(0)

    const draggableContainer = ref(null)

    function dragWindow(event) {
      // get the mouse cursor position at startup:
      clientX.value = event.client
      clientY.value = event.clientY
      document.onmousemove = (event) => {
        movementX.value = clientX.value - event.clientX
        movementY.value = clientY.value - event.clientY
        clientX.value = event.clientX
        clientY.value = event.clientY
        // set the element's new position:
        draggableContainer.value.style.top = draggableContainer.value.offsetTop - movementY.value + 'px'
        draggableContainer.value.style.left = draggableContainer.value.offsetLeft - movementX.value + 'px'
      }
      document.onmouseup = () => {
        document.onmouseup = null
        document.onmousemove = null
      }
    }

    function close() {
      store.dispatch('Identify/close')
    }
    return { dragWindow, close, draggableContainer }
  },
}
</script>
